import initialState from './initialState';
import {
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_INIT,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_SUCCESS,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_FAILURE,
  ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_RESET,
  ASSIGN_REPORT_TEMPLATE_GROUP_RESET,
  ASSIGN_REPORT_TEMPLATE_GROUP_SOFT_RESET
} from '../../actions/assignReportTemplateGroupAdmin/types';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function assignReportTemplateGroupAdmin(state = initialState, action) {
  switch (action.type) {      
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_SUCCESS: 
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "reportTemplateList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_SUCCESS: 
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "reportTemplateList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "reportTemplateList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_INIT:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateInitListAssign(initialState, state, action, "groupReportTemplatesList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_SUCCESS: 
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupReportTemplatesList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_GROUP_REPORT_TEMPLATES_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupReportTemplatesList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_INIT:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateInitListAssign(initialState, state, action, "reportTemplateGroupsList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_SUCCESS: 
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "reportTemplateGroupsList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_GET_REPORT_TEMPLATE_GROUPS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "reportTemplateGroupsList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_INIT:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateInitSaveAssign(initialState, state, action, "saveGroupReportTemplate");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_SUCCESS:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateSuccessSaveAssign(initialState, state, action, "saveGroupReportTemplate", "groupReportTemplatesList", "groupList", "report_templates_string");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_GROUP_REPORT_TEMPLATE_FAILURE:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateFailureSaveAssign(initialState, state, action, "saveGroupReportTemplate");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_INIT:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateInitSaveAssign(initialState, state, action, "saveReportTemplateGroup");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_SUCCESS:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateSuccessSaveAssign(initialState, state, action, "saveReportTemplateGroup", "reportTemplateGroupsList", "reportTemplateList");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SAVE_REPORT_TEMPLATE_GROUP_FAILURE:
      return ReducersTooling.assignTableReducers.getFetchTypeNewStateFailureSaveAssign(initialState, state, action, "saveReportTemplateGroup");
    case ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadImport");
    case ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadImport");
    case ASSIGN_REPORT_TEMPLATE_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadImport");
    case ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "import");
    case ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "import");
    case ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "import");
    case ASSIGN_REPORT_TEMPLATE_GROUP_IMPORT_RESET:
      return ReducersTooling.generalReducers.getFetchTypeNewStateReset(initialState, state, action, "import");
    case ASSIGN_REPORT_TEMPLATE_GROUP_SOFT_RESET:
      return {
        ...initialState,
        groupList: {...initialState.groupList, firstLoading: false },
        reportTemplateList: {...initialState.reportTemplateList, firstLoading: false }
      };
    case ASSIGN_REPORT_TEMPLATE_GROUP_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/assignReportTemplateGroupAdmin/index.js